/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CardSchemePriceOverride } from './CardSchemePriceOverride';
import {
    CardSchemePriceOverrideFromJSON,
    CardSchemePriceOverrideFromJSONTyped,
    CardSchemePriceOverrideToJSON,
    CardSchemePriceOverrideToJSONTyped,
} from './CardSchemePriceOverride';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';

/**
 * 
 * @export
 * @interface CreatePaymentFeeRequest
 */
export interface CreatePaymentFeeRequest {
    /**
     * 
     * @type {PaymentProvider}
     * @memberof CreatePaymentFeeRequest
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof CreatePaymentFeeRequest
     */
    paymentMethod: string;
    /**
     * 
     * @type {CreatePaymentFeeRequestCurrencyEnum}
     * @memberof CreatePaymentFeeRequest
     */
    currency: CreatePaymentFeeRequestCurrencyEnum;
    /**
     * 
     * @type {number}
     * @memberof CreatePaymentFeeRequest
     */
    fixedFeeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreatePaymentFeeRequest
     */
    variableFeePercentage: number;
    /**
     * 
     * @type {Array<CardSchemePriceOverride>}
     * @memberof CreatePaymentFeeRequest
     */
    cardSchemePriceOverrides?: Array<CardSchemePriceOverride>;
    /**
     * 
     * @type {number}
     * @memberof CreatePaymentFeeRequest
     */
    locationId?: number;
    /**
     * 
     * @type {Date}
     * @memberof CreatePaymentFeeRequest
     */
    activeFrom?: Date;
}


/**
 * @export
 */
export const CreatePaymentFeeRequestCurrencyEnum = {
    NOK: 'NOK',
    DKK: 'DKK',
    SEK: 'SEK',
    GBP: 'GBP'
} as const;
export type CreatePaymentFeeRequestCurrencyEnum = typeof CreatePaymentFeeRequestCurrencyEnum[keyof typeof CreatePaymentFeeRequestCurrencyEnum];


/**
 * Check if a given object implements the CreatePaymentFeeRequest interface.
 */
export function instanceOfCreatePaymentFeeRequest(value: object): value is CreatePaymentFeeRequest {
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('fixedFeeAmount' in value) || value['fixedFeeAmount'] === undefined) return false;
    if (!('variableFeePercentage' in value) || value['variableFeePercentage'] === undefined) return false;
    return true;
}

export function CreatePaymentFeeRequestFromJSON(json: any): CreatePaymentFeeRequest {
    return CreatePaymentFeeRequestFromJSONTyped(json, false);
}

export function CreatePaymentFeeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentFeeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'currency': json['currency'],
        'fixedFeeAmount': json['fixedFeeAmount'],
        'variableFeePercentage': json['variableFeePercentage'],
        'cardSchemePriceOverrides': json['cardSchemePriceOverrides'] == null ? undefined : ((json['cardSchemePriceOverrides'] as Array<any>).map(CardSchemePriceOverrideFromJSON)),
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'activeFrom': json['activeFrom'] == null ? undefined : (new Date(json['activeFrom'])),
    };
}

export function CreatePaymentFeeRequestToJSON(json: any): CreatePaymentFeeRequest {
    return CreatePaymentFeeRequestToJSONTyped(json, false);
}

export function CreatePaymentFeeRequestToJSONTyped(value?: CreatePaymentFeeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'currency': value['currency'],
        'fixedFeeAmount': value['fixedFeeAmount'],
        'variableFeePercentage': value['variableFeePercentage'],
        'cardSchemePriceOverrides': value['cardSchemePriceOverrides'] == null ? undefined : ((value['cardSchemePriceOverrides'] as Array<any>).map(CardSchemePriceOverrideToJSON)),
        'locationId': value['locationId'],
        'activeFrom': value['activeFrom'] == null ? value['activeFrom'] : value['activeFrom'].toISOString(),
    };
}

